import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { base64Encode } from "../../internal/utils/base64Encode.js";
import { Action } from "../../internal/Action.js";
import { QualifierValue } from "../../internal/qualifier/QualifierValue.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
/**
 * @memberOf Actions.CustomFunction
 * @see Visit {@link Actions.CustomFunction|Custom functions} for an example
 */

var CustomFunctionAction = /*#__PURE__*/function (_Action) {
  _inherits(CustomFunctionAction, _Action);

  var _super = _createSuper(CustomFunctionAction);

  /**
   *
   * @param {string} fn The custom function to use, can be a URL or a publicID
   */
  function CustomFunctionAction(fn) {
    var _this;

    _classCallCheck(this, CustomFunctionAction);

    _this = _super.call(this);
    _this.fn = fn;
    return _this;
  }

  _createClass(CustomFunctionAction, [{
    key: "encodeCustomFunctionString",
    value: function encodeCustomFunctionString(fn) {
      var encodedSource = base64Encode(fn);
      return encodedSource;
    }
    /**
     * Use a WASM as a custom function,
     * Used with the builders of `remote` and `wasm` from {@link Actions.CustomFunction|Custom functions}
     */

  }, {
    key: "asWasm",
    value: function asWasm() {
      this.mode = 'wasm';
      return this;
    }
    /**
     * Use a remote URL as a custom function
     * Used with the builders of `remote` and `wasm` from {@link Actions.CustomFunction|Custom functions}
     */

  }, {
    key: "asRemote",
    value: function asRemote() {
      this.mode = 'remote';
      return this;
    }
  }, {
    key: "prepareQualifiers",
    value: function prepareQualifiers() {
      this.encodedFn = this.fn;

      if (this.mode === 'remote') {
        this.encodedFn = this.encodeCustomFunctionString(this.fn);
      }

      return this.addQualifier(new Qualifier('fn', new QualifierValue([this.pre, this.mode, this.encodedFn])));
    }
  }, {
    key: "toString",
    value: function toString() {
      return _get(_getPrototypeOf(CustomFunctionAction.prototype), "toString", this).call(this).replace(/\//g, ':');
    }
  }]);

  return CustomFunctionAction;
}(Action);

export default CustomFunctionAction;